/**
 * Formats a date for use in URLs
 * 
 * @param {Date} date - JavaScript Date object
 * @returns {string} Date formatted as YYYYMMDD
 */
export const formatDateForUrl = (date) => {
  if (!date) return '';
  
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  
  return `${year}${month}${day}`;
};

/**
 * Creates a URL for the tips page
 * 
 * @param {string} state - State code (e.g., 'vic', 'nsw')
 * @param {string} trackName - Track name (e.g., 'caulfield', 'randwick')
 * @param {Date|string} date - Date object or string in YYYYMMDD format
 * @returns {string} Formatted URL for the tips page
 */
export const formatTipsPageUrl = (state, trackName, date) => {
  if (!state || !trackName || !date) return '';
  
  // Format the date if it's a Date object
  const formattedDate = date instanceof Date ? formatDateForUrl(date) : date;
  
  // Convert state and track to lowercase and remove spaces
  const formattedState = state.toLowerCase().replace(/\s+/g, '');
  const formattedTrack = trackName.toLowerCase().replace(/\s+/g, '-');
  
  return `/${formattedState}/${formattedTrack}/${formattedDate}`;
};
